import { useEffect, useState } from "react";
import "./App.css";
import MapView from "./Map/MapView";
import { supabase } from "./supabaseClient";

function App() {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    // Check if a user is already logged in
    supabase.auth.getUser().then(({ data }) => {
      setUser(data.user);
      setLoading(false);
    });

    // Listen for login/logout changes
    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setUser(session?.user ?? null);
      }
    );

    return () => {
      listener.subscription.unsubscribe();
    };

  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

 return (
  <div className="App">

    {/* Map always loads */}
    <MapView user={user} />

  </div>
);
}

export default App;